module.exports = __webpack_public_path__ + "assets/webgl/Frame_Ornament_base.1001.jpg.astc.59d1cbf3.ktx";